import React from "react";
import { motion } from "framer-motion";
import { Loader2 } from "lucide-react";
import { springs, tapPress } from "@/lib/motion";

/**
 * Site-wide pill button (9999px). Variants: primary (gradient), secondary
 * (outline), ghost. Includes press physics and a loading spinner state.
 */
export const SButton = React.forwardRef(function SButton(
  { variant = "primary", loading = false, disabled = false, children, className = "", type = "button", ...props },
  ref
) {
  const variantClass =
    variant === "secondary" ? "btn-secondary" : variant === "ghost" ? "" : "btn-primary";
  const isOff = disabled || loading;
  return (
    <motion.button
      ref={ref}
      type={type}
      whileTap={isOff ? undefined : tapPress}
      transition={springs.press}
      disabled={isOff}
      className={`btn-pill ${variantClass} ${isOff ? "opacity-60 pointer-events-none" : ""} ${
        variant === "ghost" ? "text-[color:var(--text-primary)]" : ""
      } ${className}`}
      {...props}
    >
      {loading && <Loader2 className="w-4 h-4 animate-spin" data-testid="btn-spinner" />}
      {children}
    </motion.button>
  );
});
